import { eraList } from "@/mocks/manga";

export default function Eras() {
  return (
    <section id="eras" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mb-8 flex flex-col gap-2">
          <p className="text-xs font-semibold tracking-widest text-primary-600">ERA LIBRARY</p>
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">按年代翻看童年漫画</h2>
              <p className="mt-2 max-w-xl text-sm text-foreground-600">
                从卷纸漫到连载时代，按你出生的年代把记忆里的老漫画一份份翻出来。
              </p>
            </div>
            <span className="text-sm text-foreground-600">共 {eraList.reduce((s, e) => s + e.count, 0)} 部归档</span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {eraList.map((era, i) => (
            <article
              key={era.id}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={era.img}
                  alt={`${era.title}${era.subtitle}老漫画合集封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-foreground-950/70 px-2.5 py-1 text-xs font-semibold text-background-50">
                  年代 {["80s", "90s", "00s"][i]}
                </span>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg text-foreground-950">{era.title}</h3>
                  <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-semibold text-accent-700">
                    {era.count} 部
                  </span>
                </div>
                <p className="mt-1 text-sm font-medium text-primary-600">{era.subtitle}</p>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{era.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {era.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-secondary-200 bg-secondary-50 px-2.5 py-1 text-xs text-secondary-800"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <a
                  href="#hot"
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
                >
                  进入翻看
                  <i className="ri-arrow-right-line text-base"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}